import { render, staticRenderFns } from "./SettingsUserDetails.vue?vue&type=template&id=3eba69be&scoped=true&"
import script from "./SettingsUserDetails.vue?vue&type=script&lang=ts&"
export * from "./SettingsUserDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eba69be",
  null
  
)

export default component.exports